import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import BrakeSevereComparison, {
  BrakeSevereComparisonError,
  BrakeSevereComparisonLoading,
} from '@di-shared/features/diag/brake/BrakeSevereComparison';
import BrakeEnergyContents, {
  BrakeEnergyContentsError,
  BrakeEnergyContentsLoading,
} from '@di-shared/features/diag/brake/BrakeEnergyContents';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import Header from '@di-shared/features/common/Header';
import ConsentBannerLoadingKr from '@di-shared/features/home/kr/ConsentBannerLoading.kr';
import ConsentBannerKr from '@di-shared/features/home/kr/ConsentBanner.kr';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

interface DiagBrakePageProps {
  vin: string;
}

function DiagBrakePage({vin}: DiagBrakePageProps) {
  const {t} = useInferableTranslation();
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30054')}</h1>
      </Header>

      <main className="content page_car_management">
        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<ConsentBannerLoadingKr />}>
            <ConsentBannerKr vin={vin} />
          </Suspense>
        </ErrorBoundary>
        <section className="section section_brake_pad">
          <ErrorBoundary fallback={<BrakeSevereComparisonError />}>
            <Suspense fallback={<BrakeSevereComparisonLoading />}>
              <BrakeSevereComparison vin={vin} />
            </Suspense>
          </ErrorBoundary>

          <ErrorBoundary fallback={<BrakeEnergyContentsError />}>
            <Suspense fallback={<BrakeEnergyContentsLoading />}>
              <BrakeEnergyContents vin={vin} />
            </Suspense>
          </ErrorBoundary>
        </section>
      </main>
    </div>
  );
}

export default DiagBrakePage;
